<template>
    <div class="header">
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
            <a href="/">
                <img src="../assets/logo-text.svg" class="nav-logo"/>
            </a>
            <a v-if="isMobile" class="dropdown-nav" type="button" @click="toggleNav">
              {{currentPage}}
              <font-awesome-icon class="caret-icon" :icon="navCaret"/>
            </a>
            <div v-if="!isMobile || !navIsCollapsed" :class="navClass">
              <ul class="navbar-nav">
                  <li class="nav-item">
                      <router-link to="/about" class="nav-link">About</router-link>
                  </li>
                  <li class="nav-item">
                      <router-link to="/contribute" class="nav-link">Contribute</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/blog" class="nav-link">Blog</router-link>
                  </li>
                  <li class="nav-item">
                      <router-link to="/search" class="nav-link">Search</router-link>
                  </li>
                  <li class="nav-item">
                      <router-link to="/add" class="nav-link">Add a Home</router-link>
                  </li>
                  <li>
                    <router-link v-if="user" class="nav-link" to="/profile">Account</router-link>
                    <button class="nav-link nav-btn" v-else @click="loginPrompt">LOG IN</button>
                  </li>
              </ul>
          </div>
        </nav>
    </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      navIsCollapsed: true,
    }
  },
  computed: {
    user() {
      return this.$auth0.user?.value?.email;
    },
    navCaret() {
      return this.navIsCollapsed ? 'angle-right': 'angle-down';
    },
    navClass() {
      return this.isMobile ? 'mobile-nav' : 'navbar-content navbar-nav ml-auto'
    },
    currentPage(){
      const page = this.$route.name;
      switch(page) {
        case 'add':
          return 'Add a Home'
        case 'login':
          return 'Log In'
        case 'yourHomes':
        case 'bulkUpload':
        case 'addBlogPost':
        case 'settings':
          return 'Account'
        default:
          return page;
      }
    },
    isMobile(){
      return window.innerWidth < 985;
    },
  },
  methods: {
    toggleNav() {
      this.navIsCollapsed = !this.navIsCollapsed
    },
    loginPrompt() {
      this.$auth0.loginWithRedirect();
    }
  }
}
</script>

<style>
/** Common **/
.navbar {
  padding: 0.5rem 1rem !important;
}
.nav-logo {
  height: 4.25rem;
  padding: 0;
}
.navbar-nav li {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  text-transform: uppercase;
}

/** Desktop **/
.navbar-content {
  display: flex;
  align-items: center;
  justify-content: right;
  width: 100%;
}

/** Mobile **/
.dropdown-nav {
  font-size: x-large;
  color: #FFFFFF;
  text-transform: uppercase;
}
.dropdown-nav:hover {
  color: #FFFFFF;
}
.caret-icon {
  margin-left: 0.5rem;
}
.mobile-nav {
  display: flex;
  width: 100%;
  padding: 0;
}
@media screen and (max-width: 985px) {
  .navbar {
    padding: 0;
  }
  .navbar-nav {
    width: 100%;
    margin: 1rem 0 0 0;
  }
  .navbar-nav li {
    text-align: center;
    font-family: 'Roboto', sans-serif;
    padding: 0;
    margin: 0;
    font-size: x-large;
    border-top: 1px solid #FFFFFF;
  }
  .nav-item {
    margin: 0;
  }
  .nav-btn {
    margin: auto;
  }
}
</style>